/* KWORQS page-transition fallback.
 * Chromium handles transitions natively via CSS view transitions; this file
 * only acts in browsers WITHOUT that support (Firefox, older Safari), giving
 * them a short exit fade so navigation still feels dimensional instead of a
 * hard cut. Does nothing when the user prefers reduced motion.
 */
(function () {
  'use strict';

  if (CSS.supports('view-transition-name', 'root')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EXIT_MS = 220;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.getAttribute('href').charAt(0) === '#') return;

    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    // Same-page hash jumps and JS links shouldn't fade the page out.
    if (url.pathname === location.pathname && url.hash) return;

    e.preventDefault();
    document.documentElement.classList.add('kw-exit');
    setTimeout(function () { location.href = a.href; }, EXIT_MS);
  });

  // Back/forward cache restores the exited page — undo the fade.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.documentElement.classList.remove('kw-exit');
  });
})();
